const EMPRESA_TOKEN_KEY = "rh-empresa-token";
const EMPRESA_USER_KEY = "rh-empresa-user";

function getBaseUrl(): string {
  return (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
}

export function getEmpresaToken(): string | null {
  return localStorage.getItem(EMPRESA_TOKEN_KEY);
}

export function getEmpresaUser(): EmpresaUser | null {
  const raw = localStorage.getItem(EMPRESA_USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as EmpresaUser;
  } catch {
    return null;
  }
}

export function setEmpresaSession(token: string, user: EmpresaUser): void {
  localStorage.setItem(EMPRESA_TOKEN_KEY, token);
  localStorage.setItem(EMPRESA_USER_KEY, JSON.stringify(user));
}

export function clearEmpresaSession(): void {
  localStorage.removeItem(EMPRESA_TOKEN_KEY);
  localStorage.removeItem(EMPRESA_USER_KEY);
}

export interface EmpresaUser {
  webcodigo: number;
  cliente_codigo: string | number;
  cliente_nome: string;
  usuario: string;
  nome?: string;
  descricao?: string;
  selecao?: number | string;
  abrevaga?: number | string;
  altvaga?: number | string;
  retcand?: number | string;
}

export interface EmpresaSessionResponse {
  token: string;
  webcodigo: number;
  cliente_codigo: string | number;
  cliente_nome: string;
  usuario: string;
  nome?: string;
  descricao?: string;
  ncontrato?: string;
  contrato?: string;
  selecao?: number | string;
  abrevaga?: number | string;
  altvaga?: number | string;
  retcand?: number | string;
}

export async function empresaLogin(
  usuario: string,
  senha: string,
): Promise<EmpresaSessionResponse | null> {
  const url = `${getBaseUrl()}/empresa/session`;
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ usuario: usuario.trim(), senha }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { error?: string }).error || "Login falhou.");
  }
  return res.json();
}

export async function empresaFetch<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const token = getEmpresaToken();
  if (!token) {
    throw new Error("Empresa não autenticada.");
  }
  const url = `${getBaseUrl()}/empresa${path.startsWith("/") ? path : `/${path}`}`;
  const res = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(options?.headers as Record<string, string>),
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const msg = (err as { error?: string }).error || "Erro na requisição.";
    if (res.status === 401 || /token inválido/i.test(msg)) {
      clearEmpresaSession();
      const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
      window.location.href = `${base}/empresa/login`;
      throw new Error(msg);
    }
    throw new Error(msg);
  }
  return res.json();
}

export function verificarCpfEmpresa(
  cpf: string,
): Promise<{ encontrado: boolean; nome: string | null }> {
  const base = getBaseUrl();
  const clean = String(cpf).replace(/\D/g, "");
  return fetch(`${base}/empresa/verificar-cpf`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ cpf: clean }),
  }).then((r) => {
    if (!r.ok) throw new Error("Erro ao verificar CPF.");
    return r.json();
  });
}
